export default __webpack_public_path__ + "static/media/notifications-DE.eea0fa3b.png";